import React from 'react'
import nextRollProjectImage from '../../media/clients/next-roll-project.webp'
import { SOFTWARE_SERVICES_PATH } from '../../routes'
import Project from '../../components/Project'
import { otherProjectsWithout } from '../otherProjectsCardsInformation'

export default class NextRollProject extends React.Component {
    name(){
        return 'nextroll'
    }

    service(){
        return 'softwareDevelopment'
    }

    texts() {
        return this.props.texts
    }

    solutionsTexts() {
        return this.texts()['solutions']
    }

    otherProjects() {
        return otherProjectsWithout(this.name(),
            this.service(), this.solutionsTexts())
    }

    render() {
        return (
            <Project
                texts={this.texts()}
                projectImg={nextRollProjectImage}
                otherProjects={this.otherProjects()}
                projectAreaPath={SOFTWARE_SERVICES_PATH}
            />
        )
    }
}
